module.exports = __webpack_public_path__ + "img/b2b.7944268f.svg";